/** GridMap parser registration. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseGridMap } from './parser';
const gridMapRegistration = {
    typeName: 'GridMap',
    parser: parseGridMap,
};
nodeRegistry.register(gridMapRegistration);
//# sourceMappingURL=index.js.map